<template>
    <van-sticky>
        <div class="bookingBack" :style="{ 'background': isDark ? '#1A3232' : '#fff'}">
            <img v-if="!isDark" src="@/assets/shop/back_blue.png" alt="" @click="handleBack">
            <img v-else src="@/assets/shop/back_white.png" alt="" @click="handleBack" alt="">
            <div v-if="title != ''" :style="{'color': effectiveTextColor, marginLeft:'5px'}" :class="{'titleCenter':isCenter}">{{title}}</div>
            <!-- 右侧自定义插槽：用于放置操作按钮（如Delete） -->
            <div v-if="$slots.right" class="right-action">
                <slot name="right"></slot>
            </div>
        </div>
    </van-sticky>
</template>
<script>
export default {
    name:'ShopBack',
    props:{
        title:{
            type:String,
            default:''
        },
        isDark:{
            type:Boolean,
            // 统一顶部栏风格：默认使用深色背景（#1A3232）
            default:true
        },
        textColor:{
            type:String,
            default:'#fff'
        },
        isCenter:{
            type:Boolean,
            default:false
        }
    },
    computed: {
        // 深色模式下强制白字，避免页面仍传入 #333 导致看不清
        effectiveTextColor() {
            return this.isDark ? '#fff' : this.textColor
        }
    },
    methods:{
        handleBack(){
            this.$router.go(-1)
        },
    }
}
</script>
<style lang="scss" scoped>
    .bookingBack{
        width: 100%;
        height: 2.75rem;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        box-sizing: border-box;
        padding:0 1rem;
        img{
            width: 1.5rem;
            height: 1.5rem;
            display: block;
        }
        .titleCenter{
            position: absolute;
            left: 50%;
            transform: translate(-50%);
        }
        .right-action{
            position: absolute;
            right: 1rem;
            height: 2.75rem;
            display: flex;
            align-items: center;
            top: 0;
        }
    }
</style>
